const madFormatter = new Intl.NumberFormat('ar-MA', {
  style: 'currency',
  currency: 'MAD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format amounts as Moroccan Dirham in Arabic (e.g. 4.200,00 د.م.). Includes 0. */
export const formatCurrency = (amount) => {
  const numAmount = Number(amount);
  const value = Number.isFinite(numAmount) ? numAmount : 0;
  return madFormatter.format(value);
};

export const formatCurrencySimple = formatCurrency;
